import React from "react";
import InformationDialog from "components/InformationDialog/InformationDialog";
import { styled } from "@mui/material/styles";
import { css } from "@emotion/react";

type Props = {
  participantTypeDisplayNames: string;
  isOpen: boolean;
  onClose: (confirmed: boolean) => void;
};

// TODO: BLD-6790 This needs to change its content
const ParticipantCannotRemoveInformationDialog: React.FC<Props> = ({
  participantTypeDisplayNames,
  isOpen,
  onClose,
}) => {
  return (
    <InformationDialog title={`Required ${participantTypeDisplayNames} role`} isOpen={isOpen} onClose={onClose}>
      <StyledContent>
        <p>A valid application needs to have {participantTypeDisplayNames} role.</p>
        <br />
        <p>You can remove a required role from a participant only by transferring the role to another participant.</p>
        <br />
        <p>
          To do this, add or edit the target participant, select the role to be transferred and then confirm the
          transfer.
        </p>
      </StyledContent>
    </InformationDialog>
  );
};

const StyledContent = styled("div")(
  ({ theme }) => css`
    max-width: 600px;
    padding-bottom: 24px;
  `
);

export default ParticipantCannotRemoveInformationDialog;
